// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"DownloadButton__downloadIcon--3hefg","downloadReleaseLink":"DownloadButton__downloadReleaseLink--1LvqL"};